import { Meet } from "./Meet";

class ThongBaoPhienHopsEndpoint extends Meet {
  constructor() {
    super("/ThongBaoPhienHops");
  }

  getFilterByDuAnId = (filter = []) => this.SearchAllOdata(`?$select=DonThuId,VanBanId&$filter=${filter.join(' and ')}`, null, null, true);
}
export default new ThongBaoPhienHopsEndpoint();